import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Info({ idVariant = '', className }: Props) {
  return (
    <IconBase name="info" w={24} className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.5 10V18H11.5V10H12.5ZM12.5 8V6H11.5V8H12.5Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Info
